import React from 'react';
import './Banner.css';
import Carousel from './Carousel';

function Banner({ imageList }) {
  return (
    <div className="banner-container">
      <Carousel images={imageList}/>
    </div>
  );
}

export default Banner;
